<template>
  <div class="about-main slide-item">
    <div class="slide-content">
      <div class="title">
        {{data.name}}
        <div class="line"></div>
      </div>

      <div class="detail-item">
        <img :src="data.img" alt="">
        <div>
          {{data.contect}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import product from '@/assets/js/product.js'
export default {
  data() {
    return {
      data: {},
    }
  },
  mounted() {
    const type = this.$route.query.p
    this.data = product[type] || ''
  },
  methods: {},
}
</script>

<style>
</style>